'use strict';

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { ValidateInput, NumberInputCodes } from '../lib/Constants';

const SysKeyForm = (props) => {
    const [value, setValue] = useState("");
    const handleChange = (e) => {
        let value = e.target.value;
        setValue(value);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        props.onCleanup(value);
    };
    return (
        <Form onSubmit={handleSubmit} className="w-100">
            <h2 className="h4">Locked Syskey</h2>

            <div className="d-flex gap-3 align-items-end">
                <FloatingLabel
                    controlId="sysKey"
                    label="SysKey"
                    className="w-50">
                    <Form.Control
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck="false"
                        placeholder="123456789"
                        onChange={handleChange}
                        onKeyDown={(e) => ValidateInput(e, NumberInputCodes)}
                        value={value}
                    />
                </FloatingLabel>

                <Button
                    size="sm"
                    type="submit"
                    disabled={!value}>
                    Cleanup
                </Button>

                {/*<Button*/}
                {/*    size="sm"*/}
                {/*    variant="secondary"*/}
                {/*    type="button"*/}
                {/*    onClick={handleShowSysKeys}>*/}
                {/*    {showSysKeys ? "Hide Syskeys" : "Show Syskeys"}*/}
                {/*</Button>*/}
            </div>
        </Form>
    );
};

SysKeyForm.propTypes = {
    onCleanup: PropTypes.func.isRequired,
};

export default SysKeyForm;

